import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import PersonIcon from "@mui/icons-material/Person";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import AnonymousUserLayout from "../../common/anonymous-user-layout/anonymous-user-layout";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import "react-toastify/dist/ReactToastify.css";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Colors from "../../../config/colors";
import { getUserToken } from "../../../libs/user";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import jwt_decode from "jwt-decode";

function Login() {
  const navigate = useNavigate();

  const [loginError, setLoginError] = useState("");
  const [isLogin, setIsLogin] = useState(false);

  const token = getUserToken();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const login = (data) => {
    setIsLogin(true);
    setLoginError("");
    if (data.credential) {
      const data1 = jwt_decode(data.credential);
      console.log("User Info:", data1);
      console.log("Credential Response:", data);
      navigate("/app/auth", {
        state: { credential: data.credential },
      });
    } else if (data.username && data.password) {
      navigate("/app/auth", {
        state: { username: data.username, password: data.password },
      });
    } else {
      setIsLogin(false);
      setLoginError("Invalid Credentials");
    }
  };

  useEffect(() => {
    if (token) {
      navigate("/app/offers");
      return;
    }
    navigate("/login");
  }, []);

  const theme = createTheme({
    palette: {
      primary: {
        main: Colors.primary,
      },
      secondary: {
        main: Colors.secondary,
      },
    },
    components: {
      MuiInputLabel: {
        defaultProps: {
          sx: {
            fontSize: "20px",
          },
        },
      },
      MuiOutlinedInput: {
        defaultProps: {
          sx: {
            fontSize: "20px",
          },
        },
      },
    },
  });

  return (
    <>
      <ThemeProvider theme={theme}>
        <AnonymousUserLayout />
        <Container
          component="main"
          sx={{
            height: "calc(100vh - 64px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "64px",
          }}
        >
          <Box
            style={{
              width: "fit-content",
            }}
          >
            <Box
              style={{
                width: "500px",
                padding: "54px 28px",
                border: "1px solid rgb(204, 204, 204)",
                borderRadius: "8px",
                background: "#fff",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <Typography
                  variant="h4"
                  style={{
                    color: "#000",
                    marginBottom: "24px",
                    fontWeight: "bold",
                  }}
                >
                  Login
                </Typography>
              </Box>
              <GoogleOAuthProvider clientId="837696981065-ehco9hkqee18hrlnala4tnt6d8jci177.apps.googleusercontent.com">
                <GoogleLogin
                  theme="filled_blue"
                  shape="pill"
                  size="large"
                  hosted_domain="joinabound.com"
                  onSuccess={(credentialResponse) => {
                    login(credentialResponse);
                  }}
                  onError={() => {
                    console.log("Login Failed");
                  }}
                />
              </GoogleOAuthProvider>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  textAlign: "center",
                  marginTop: "20px",
                  marginBottom: "20px",
                }}
              >
                <hr
                  style={{
                    flex: 1,
                    border: "none",
                    borderTop: "1px solid #000",
                  }}
                />
                <span
                  style={{
                    padding: "0 10px",
                    color: "#666",
                    fontWeight: "bold",
                    fontSize: "25px",
                  }}
                >
                  OR
                </span>
                <hr
                  style={{
                    flex: 1,
                    border: "none",
                    borderTop: "1px solid #000",
                  }}
                />
              </div>
              <form onSubmit={handleSubmit(login)}>
                <TextField
                  {...register("username", {
                    required: true,
                  })}
                  error={errors.username}
                  helperText={errors.username ? "Please Enter Username" : ""}
                  margin="normal"
                  fullWidth
                  label="Username"
                  autoFocus
                  InputProps={{
                    endAdornment: <PersonIcon sx={{ color: "#ccc" }} />,
                    autoComplete: "off",
                  }}
                />
                <TextField
                  {...register("password", {
                    required: true,
                    minLength: 8,
                  })}
                  error={errors.password}
                  helperText={errors.password ? "Please Enter Password" : ""}
                  margin="normal"
                  fullWidth
                  label="Password"
                  type="password"
                  InputProps={{
                    endAdornment: <LockOutlinedIcon sx={{ color: "#ccc" }} />,
                    autoComplete: "off",
                  }}
                />
                <Button
                  fullWidth
                  size="large"
                  sx={{
                    fontSize: "20px",
                    marginTop: "16px",
                    color: "#edc865",
                    fontWeight: "bold",
                    height: "56px",
                    "&:hover": {
                      background: "#edc865",
                      color: "#7a5700",
                    },
                  }}
                  variant="contained"
                  type="submit"
                >
                  Login
                  {isLogin === true && (
                    <i
                      style={{ marginLeft: "auto" }}
                      className={`fa fa-circle-o-notch ${
                        true ? "fa-spin" : ""
                      }`}
                      aria-hidden="true"
                    ></i>
                  )}
                  {isLogin === false && (
                    <ArrowForwardIcon style={{ marginLeft: "auto" }} />
                  )}
                </Button>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Typography sx={{ mt: 2, color: "#676767" }}>
                    <span
                      style={{ textDecoration: "none" }}
                      className="text-danger"
                    >
                      &nbsp;{loginError}
                    </span>
                  </Typography>
                  <Typography sx={{ mt: 5, color: "#676767" }}>
                    <Link
                      to="/forget-password"
                      style={{ textDecoration: "none", color: "#676767" }}
                    >
                      Forgot Password
                      <ArrowForwardIcon
                        style={{ height: "16px", marginLeft: "auto" }}
                      />
                    </Link>
                  </Typography>
                </Box>
              </form>
            </Box>
          </Box>
        </Container>
      </ThemeProvider>
    </>
  );
}

export default Login;
